module.exports = __webpack_public_path__ + "img/postback-step-4.en.2aab0032.jpg";